import { Version } from 'components/common/UploadFileModal/components/programLibrary.types';
import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params) => {
    const data = new FormData();
    data.append('file', params.file, params.fileName);

    const payload: any = {
        projectId: params.projectId,
        contractId: params.contractId,
        contractName: params.contractName,
        uploadingUser: params.uploadingUser,
        versions: params.versions,
        customVersionName: params.customVersionName,
        isBaseline: params.isBaseline,
        isIntegratedProjects: params.isIntegratedProjects,
        warningCheck: params.warningCheck,
        language: params.language,
        runCPM: params.runCPM,
    };

    data.append('request', JSON.stringify(payload));

    return network
        .post('api/bo/uploadProjectFile', data, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers['Content-Type'] = 'multipart/form-data';
                    }
                    return data;
                },
            ],
        })
        .then(() => {
            return true;
        });
};
export const useMutationUploadProjectFile = () => {
    return useMutation<unknown, QueryError, UploadProjectsPayload>({ mutationFn: (params) => mutationFn(params) });
};

export interface UploadProjectsPayload {
    projectId: number;
    contractId: number | null;
    contractName: string;
    uploadingUser: string;
    file: Blob;
    fileName: string;
    versions: Version[];
    customVersionName: string;
    isBaseline: boolean;
    isIntegratedProjects: boolean;
    warningCheck: boolean;
    runCPM: boolean;
}
